import React from "react";
import { useRoutes, useRedirect } from "hookrouter";
import { routes, guestRoutes } from "./Routes";
import NotFound from "./NotFound";
import Chat from "./components/Chat";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import { AppContext } from "./contexts/AppContext";
import { useAuth } from "./components/Auth/AuthHooks";

const Router = () => {
  const { token, init } = useAuth();
  const [dont, setDont] = React.useState(null);

  const { chat } = React.useContext(AppContext);
  useRedirect("/user/", "/user");
  const routeResult = useRoutes(token ? routes : guestRoutes);

  React.useEffect(() => {
    init();
  }, [dont]);

  return (
    <React.Fragment>
      {token && chat && <Chat />}
      {token && <Navbar />}
      <div
        style={{
          flex: 1,
        }}
      >
        {routeResult || <NotFound />}
      </div>
      {token && <Footer />}
    </React.Fragment>
  );
};

export default Router;
